var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNextjsBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.256,
    height: 115.256,
    viewBox: "0 0 115.256 115.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Nextjs-black",
    d: "M34.577,34.577l3.115-2.249a3.842,3.842,0,0,0-6.956,2.249Zm23.051,73A49.944,49.944,0,0,1,7.684,57.628H0a57.628,57.628,0,0,0,57.628,57.628Zm49.944-49.944a49.944,49.944,0,0,1-49.944,49.944v7.684a57.628,57.628,0,0,0,57.628-57.628ZM57.628,7.684a49.944,49.944,0,0,1,49.944,49.944h7.684A57.628,57.628,0,0,0,57.628,0Zm0-7.684A57.628,57.628,0,0,0,0,57.628H7.684A49.944,49.944,0,0,1,57.628,7.684ZM38.419,92.2V34.577H30.735V92.2ZM31.462,36.826,81.407,105.98l6.228-4.5L37.691,32.327Zm45.375-6.091v46.1h7.684v-46.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextjsBlack);
export default __webpack_public_path__ + "static/media/Nextjs-black.0c559c2ae9c1cdbb7c2df4dc7bd94a3c.svg";
export { ForwardRef as ReactComponent };